import { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { user } from '../classes/user.js';
import Navigator from "../components/navigator/index.jsx";
import { useAuth } from '../hooks/useAuth.js';
import useWindowSize from '../hooks/useWindowSize.js';
import Clients from "../pages/clients/index.jsx";
import ClientDetails from "../pages/clientDetails/index.jsx";
import Commissioned from "../pages/commissioned/index.jsx";
import Home from "../pages/home/index.jsx";
import Leads from '../pages/leads/index.jsx';
import Logout from '../pages/logout/index.jsx';
import Logs from '../pages/logs/index.jsx';
import RegisterUser from "../pages/registerUser/index.jsx";
import Reviews from "../pages/reviews/index.jsx";
import IfoodRequests from "../pages/ifoodRequests/index.jsx";
import OpenCompanies from "../pages/openCompanies/index.jsx";
import Users from "../pages/users/index.jsx";
import SignIn from '../pages/signIn/index.jsx';
import axios from '../services/axios-config.js';
import * as storage from '../services/storage.js';
import { setNavigate } from './rootNavigator.js';



export default function AppRoutes(){

    const width = useWindowSize();

    const navigator = useNavigate();

    setNavigate(navigator);

    const {userAuth, login, logout} = useAuth();


    useEffect(() => {

        const initApp = async () => {
            try{
                const res = await axios.get(`/admin/token/validate`);
                
                if(res.data){
                    user.insert(res.data);
                    login();
                }

            } catch (e) {
                console.error('ERROR - INIT APP FUNCTION:', e);
                logout();
            }
        }

        initApp();

    }, [])


    
    return(
        <div style={{flex: 1, width: '100%', heigth: '100%', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between'}}>
        
            {userAuth && <Navigator/>}
        
            <div style={{flex: 1, minWidth: 0, marginTop: width <= 768 ? 60 : 0}}>
                <div style={{width: '100%', height: `calc(100vh)`, overflowY: 'auto', overflowX: 'hidden'}}>
                    <Routes>
                        <Route path="/" index Component={SignIn} />
                        <Route path="/home" index Component={Home} />
                        <Route path="/clients" Component={Clients} />
                        <Route path="/clients/:id" Component={ClientDetails} />
                        <Route path="/leads" Component={Leads} />
                        <Route path="/commissioned" Component={Commissioned} />
                        <Route path="/reviews" Component={Reviews} />
                        <Route path="/ifood-requests" Component={IfoodRequests} />
                        <Route path="/open-companies" Component={OpenCompanies} />
                        <Route path="/users" Component={Users} />
                        <Route path="/logs" Component={Logs} />
                        <Route path="/register-user" Component={RegisterUser} />
                        <Route path="/logout" Component={Logout} />
                    </Routes>
                </div>
        
            </div>
        </div>

    )
}